// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "#logout[data-v-e5746276]{cursor:pointer}h3[data-v-e5746276]{-webkit-text-fill-color:transparent;-webkit-box-decoration-break:clone;background:linear-gradient(-85deg,#3674b9,#b5b173);-webkit-background-clip:text}hr[data-v-e5746276]{width:32px;height:3px;border-radius:3px}a[data-v-e5746276]{cursor:pointer}", ""]);
// Exports
module.exports = exports;
